import { useEffect, useState } from 'react';
import { useAppDispatch } from './reduxhook';
import { addModelMappings, addModelsForKey } from '../redux/slices/modelSlice';
import apiCall from '../utils/apiCall';
import { GET_MODELS } from '../endpoint';
import hyperscaler_mapping from '../data/modelMapping';
import { ModelInterface, ModelsState, ModelMappings } from '../types/models';

export const useModels = (userAccount: any) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchModels = async () => {
      if (!userAccount?.idTokenClaims) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await apiCall("POST", GET_MODELS);
        const chatModels: ModelInterface[] = [];
        const imageModels: ModelInterface[] = [];
        const multimodalModels: ModelInterface[] = [];
        const embeddingModels: ModelInterface[] = [];

        const mappings: ModelMappings = {};

        response?.result?.forEach((model: ModelInterface) => {
          if (model.mode === "chat") {
            chatModels.push(model);
          } else if (model.mode === "image_generation") {
            imageModels.push(model);
          } else if (model.mode === "multi_modal") {
            multimodalModels.push(model);
            chatModels.push(model);
          } else if (model.mode === "embedding") {
            embeddingModels.push(model);
          }
          
          const provider = model?.model?.split("/")[0] ?? "psl";
          mappings[model.model_name] = {
            name: model.model_name?.replaceAll("-", " "),
            icon: hyperscaler_mapping[provider] || hyperscaler_mapping["default"],
          };
        });

        dispatch(
          addModelsForKey({
            chat: chatModels,
            image: imageModels,
            multimodal: multimodalModels,
            embedding: embeddingModels,
          })
        );
        dispatch(addModelMappings(mappings));
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch models');
        console.error('Error fetching models:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchModels();
  }, [userAccount, dispatch]);

  return { isLoading, error };
};

